<mat-toolbar color="primary" class="app-toolbar">
  <button mat-icon-button class="back-button" aria-label="Back button" *ngIf="showBack" (click)="onBackClick()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>{{title}}</span>
</mat-toolbar>
